import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import LOGO from '../assets/logo.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email:'', password:'' });
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.must_change_password) {
        // Force password change — redirect to profile with flag
        navigate('/profile?must_change=true');
        toast('🔑 You must change your default password to continue.', {
          duration: 6000,
          style: { background:'#FEF1E8', color:'#D4621A', border:'1px solid #F07830' }
        });
      } else {
        navigate('/');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed. Check your credentials.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={LOGO} alt="OMIYE MFB" style={{ width:100, filter:'drop-shadow(0 4px 12px rgba(0,0,0,0.15))' }} />
        </div>
        <div className="login-title">OMIYE MFB HelpDesk</div>
        <div className="login-sub">Sign in with your staff credentials</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" placeholder="yourname@omiyemfb.com"
              value={form.email} onChange={e => setForm({ ...form, email:e.target.value })} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position:'relative' }}>
              <input className="form-input" type={showPw ? 'text' : 'password'}
                placeholder="Enter your password" style={{ paddingRight:40 }}
                value={form.password} onChange={e => setForm({ ...form, password:e.target.value })} required />
              <span onClick={() => setShowPw(!showPw)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', cursor:'pointer', fontSize:16, color:'var(--text3)', userSelect:'none' }}>
                {showPw ? '🙈' : '👁️'}
              </span>
            </div>
          </div>
          <div style={{ textAlign:'right', marginBottom:16, marginTop:-6 }}>
            <Link to="/forgot-password" style={{ fontSize:12, color:'var(--sky)', fontWeight:500 }}>
              Forgot password?
            </Link>
          </div>
          <button className="btn btn-primary login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : '🔐 Sign In'}
          </button>
        </form>
        <div style={{ marginTop:20, padding:'10px 14px', background:'var(--surface)', borderRadius:10, fontSize:11, color:'var(--text3)', textAlign:'center', border:'1px solid var(--border)' }}>
          For access issues, contact your System Administrator
        </div>
      </div>
    </div>
  );
}
